import GaConnect from "@similarweb/features/lib/components/GaConnect";
import { useTrack } from "pro-features/components/WithTrack/src/useTrack";
import { getI18nParams } from "app/filters/i18nFilter";

type GAWizardModalProps = {
    isOpen: boolean;
    onClose(): void;
};

const GA_CONNECT_SOURCE_TYPE = "pro";

export const GAWizardModal = (props: GAWizardModalProps) => {
    const { isOpen, onClose } = props;
    const [track] = useTrack();

    const handleClose = () => {
        onClose();
    };

    return (
        <GaConnect
            type={GA_CONNECT_SOURCE_TYPE}
            isPrivateConnectionAvailable={true}
            isOpen={isOpen}
            track={track}
            onRequestClose={handleClose}
            i18nParams={getI18nParams()}
        />
    );
};
